var _path, _rect, _rect2, _path2, _rect3, _rect4, _rect5, _path3, _path4, _path5, _path6, _rect6, _path7, _path8, _path9, _path10, _path11, _rect7, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndus7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 59,
    viewBox: "0 0 50 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 56.5C3.10526 55.3681 5.97895 53.7834 8.63158 56.5C11.2842 59.2166 13.4211 57.6319 14.1579 56.5C14.7105 55.7454 16.2579 54.6889 18.0263 56.5C19.7948 58.3111 21.7105 57.2546 22.4474 56.5C23.1842 55.7454 25.1 54.6889 26.8684 56.5C28.6369 58.3111 30.1842 57.2546 30.7368 56.5C31.4737 55.7454 33.3895 54.6889 35.1579 56.5C36.9263 58.3111 38.8421 57.2546 39.5789 56.5C40.3158 55.7454 42.2315 54.6889 44 56.5",
    stroke: "#000064"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 46.5,
    width: 5,
    height: 8,
    stroke: "#000064"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.5,
    y: 46.5,
    width: 5,
    height: 8,
    stroke: "#000064"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42 37.5H2C1.17157 37.5 0.5 38.1716 0.5 39V41C0.5 41.8284 1.17157 42.5 2 42.5H42C42.8284 42.5 43.5 41.8284 43.5 41V39C43.5 38.1716 42.8284 37.5 42 37.5Z",
    stroke: "#000064"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 42.5,
    width: 9,
    height: 4,
    stroke: "#000064"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 30.5,
    width: 18,
    height: 7,
    stroke: "#000064"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 42.5,
    width: 9,
    height: 4,
    stroke: "#000064"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 37.5V34.5H5.5M20.5 34.5H18M5.5 34.5L9.5 11.5H13.5L18 34.5M5.5 34.5H18",
    stroke: "#000064"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 25.5L17.5 34.5M16.5 25.5L6 34.5",
    stroke: "#000064"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 25.5H16",
    stroke: "#000064"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 25L14.5 16.5M16 25.5L8.5 16.5M8.5 15.5H14.5",
    stroke: "#000064"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 6.5,
    width: 4,
    height: 4,
    stroke: "#000064"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 30.5L27.5 1H31.5L35.5 30.5",
    stroke: "#000064"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 30L34 20.5M35.5 30L24.5 20.5M34 20H25L33 11",
    stroke: "#000064"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26 11.5L33.5 20.5M26 10.5H33",
    stroke: "#000064"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32 4H46L49 8H32.5",
    stroke: "#000064"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46 8V24",
    stroke: "#000064"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 42.5,
    y: 24.5,
    width: 7,
    height: 7,
    rx: 0.5,
    stroke: "#000064"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24 34.5H27.5",
    stroke: "#000064"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31 34.5H34.5",
    stroke: "#000064"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndus7);
export default __webpack_public_path__ + "static/media/indus7.b278747bfcb650243195d10008e7c14f.svg";
export { ForwardRef as ReactComponent };